import { domainUrl } from '../constants';

export const API_GET_POST_USERS = `${domainUrl}auth/users`;
export const API_GET_PUT_DELETE_USER_DETAIL = `${domainUrl}auth/users/{slug}`;
export const API_GET_2FACTOR_ENABLE = `${domainUrl}auth/2fa/enable`;
export const API_GET_2FACTOR_DISABLE = `${domainUrl}auth/2fa/disable`;
